// 瓜田日报 · 内容演示数据
// 全部为编辑部整理/示例性质的公开热点与趋势资讯，不针对任何具体个人。

export interface HotItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: 'up' | 'down' | 'flat' | 'new';
  time: string;
}

export interface BreakingItem {
  title: string;
  summary: string;
  status: '追踪中' | '新进展' | '已收尾';
  time: string;
  field: string;
  image: string;
}

export interface ReviewItem {
  category: string;
  title: string;
  excerpt: string;
  minutes: number;
  date: string;
  image: string;
  link: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

// 全网热榜（按栏目分组的演示榜单）
export const hotGroups: { group: string; list: HotItem[] }[] = [
  {
    group: '全网热榜',
    list: [
      { rank: 1, title: '多地音乐节扎堆开唱 现场人气持续走高', tag: '现场', heat: '932万', trend: 'up', time: '12分钟前' },
      { rank: 2, title: '经典亲子综艺重启录制 阵容引发热议', tag: '综艺', heat: '865万', trend: 'up', time: '28分钟前' },
      { rank: 3, title: '暑期档新片口碑两极 观众吵翻评论区', tag: '影视', heat: '812万', trend: 'up', time: '36分钟前' },
      { rank: 4, title: '本地博主晒家乡夜经济 万人点赞催更', tag: '生活', heat: '704万', trend: 'down', time: '1小时前' },
      { rank: 5, title: '新一波网络热梗走红 出处已考证', tag: '热梗', heat: '668万', trend: 'up', time: '1小时前' },
      { rank: 6, title: '业余球队爆冷晋级 网友直呼剧本感', tag: '体育', heat: '590万', trend: 'new', time: '1小时前' },
      { rank: 7, title: '国产AI小工具上线 教程刷爆首页', tag: '科技', heat: '537万', trend: 'up', time: '2小时前' },
      { rank: 8, title: '夜市小吃摊主走红 排队三小时起步', tag: '生活', heat: '489万', trend: 'down', time: '2小时前' },
      { rank: 9, title: '乡村纪录片单集百万播放 网友追更', tag: '纪录片', heat: '452万', trend: 'flat', time: '3小时前' },
      { rank: 10, title: '高口碑话剧开启巡演 首站票已售罄', tag: '演出', heat: '398万', trend: 'up', time: '3小时前' },
    ],
  },
  {
    group: '影视娱乐',
    list: [
      { rank: 1, title: '暑期档新片口碑两极 观众吵翻评论区', tag: '影视', heat: '812万', trend: 'up', time: '36分钟前' },
      { rank: 2, title: '经典亲子综艺重启录制 阵容引发热议', tag: '综艺', heat: '865万', trend: 'up', time: '28分钟前' },
      { rank: 3, title: '高口碑话剧开启巡演 首站票已售罄', tag: '演出', heat: '398万', trend: 'up', time: '3小时前' },
      { rank: 4, title: '老片修复重映 弹幕里全是回忆', tag: '影视', heat: '420万', trend: 'up', time: '2小时前' },
      { rank: 5, title: '音乐厂牌官宣城市快闪 乐迷蹲票', tag: '音乐', heat: '361万', trend: 'new', time: '3小时前' },
    ],
  },
  {
    group: '体育赛场',
    list: [
      { rank: 1, title: '业余球队爆冷晋级 网友直呼剧本感', tag: '体育', heat: '590万', trend: 'new', time: '1小时前' },
      { rank: 2, title: '区域篮球联赛决赛 场场打到加时', tag: '体育', heat: '402万', trend: 'up', time: '2小时前' },
      { rank: 3, title: '马拉松周末开跑 城市赛道火出圈', tag: '体育', heat: '355万', trend: 'down', time: '3小时前' },
      { rank: 4, title: '民间健身达人挑战 纪录连续刷新', tag: '健身', heat: '301万', trend: 'up', time: '4小时前' },
    ],
  },
  {
    group: '科技前沿',
    list: [
      { rank: 1, title: '国产AI小工具上线 教程刷爆首页', tag: '科技', heat: '537万', trend: 'up', time: '2小时前' },
      { rank: 2, title: '新旗舰手机发布 影像升级成焦点', tag: '数码', heat: '428万', trend: 'up', time: '2小时前' },
      { rank: 3, title: '开源项目一周破十万星 开发者狂喜', tag: '开源', heat: '388万', trend: 'new', time: '3小时前' },
      { rank: 4, title: '家庭机器人进入众测 萌翻众人', tag: '科技', heat: '342万', trend: 'flat', time: '4小时前' },
    ],
  },
  {
    group: '生活百态',
    list: [
      { rank: 1, title: '本地博主晒家乡夜经济 万人点赞催更', tag: '生活', heat: '704万', trend: 'down', time: '1小时前' },
      { rank: 2, title: '夜市小吃摊主走红 排队三小时起步', tag: '生活', heat: '489万', trend: 'down', time: '2小时前' },
      { rank: 3, title: '乡村纪录片单集百万播放 网友追更', tag: '纪录片', heat: '452万', trend: 'flat', time: '3小时前' },
      { rank: 4, title: '返乡青年开民宿 把日子过成诗', tag: '乡村', heat: '326万', trend: 'up', time: '4小时前' },
    ],
  },
];

// 突发大事
export const breakingList: BreakingItem[] = [
  {
    title: '南方多城遭遇强降雨 应急部门全力抢险',
    summary: '本轮降雨仍在持续，相关部门已启动应急预案，多支救援队伍赶赴一线。',
    status: '追踪中',
    time: '更新于 3 分钟前',
    field: '社会',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20overcast%20city%20street%20during%20heavy%20rain%20with%20reflective%20pavement%20and%20umbrellas%2C%20warm%20editorial%20photojournalism%20mood%2C%20soft%20muted%20tone%2C%20high%20detail%20atmospheric%20composition&width=800&height=600&seq=brk-rain&orientation=landscape',
  },
  {
    title: '大型音乐节首日开唱 主办方宣布扩容加场',
    summary: '首日现场人气爆棚，主办方临时加开多组通道并增派安保，明日门票基本售罄。',
    status: '新进展',
    time: '更新于 26 分钟前',
    field: '现场',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20outdoor%20music%20festival%20stage%20at%20dusk%20with%20crowd%20silhouettes%20and%20stage%20lights%2C%20warm%20amber%20and%20coral%20tones%2C%20energetic%20editorial%20photography%2C%20dynamic%20composition&width=800&height=600&seq=brk-fest&orientation=landscape',
  },
  {
    title: '省级篮球联赛决赛结束 加时绝杀夺魁',
    summary: '比赛最后五秒上演绝杀，现场欢呼震天，该场直播观看量创联赛新高。',
    status: '已收尾',
    time: '更新于 1 小时前',
    field: '体育',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20indoor%20basketball%20game%20final%20seconds%20with%20player%20shooting%20under%20bright%20arena%20lights%2C%20warm%20tonal%20sports%20photojournalism%2C%20motion%20and%20tension%2C%20editorial%20style&width=800&height=600&seq=brk-ball&orientation=landscape',
  },
  {
    title: '国产开源框架突然爆红 官方加急发布教程',
    summary: '项目热度一夜飙升，维护团队连夜更新文档，社区交流群排队涌入。',
    status: '追踪中',
    time: '更新于 2 小时前',
    field: '科技',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20developer%20coding%20on%20laptop%20with%20code%20glowing%20on%20screen%20in%20warm%20ambient%20light%2C%20tech%20editorial%20photography%2C%20cozy%20workspace%2C%20soft%20depth%20of%20field&width=800&height=600&seq=brk-dev&orientation=landscape',
  },
];

// 大事件复盘
export const reviewList: ReviewItem[] = [
  {
    category: '现场复盘',
    title: '一场音乐节如何点燃一座城：从筹备到散场的完整复盘',
    excerpt: '从招商、安保、交通接驳到现场体验，我们拆解一场大型音乐节背后的十几个关键环节，看看人气与秩序如何两全。',
    minutes: 9,
    date: '2026-09-08',
    image: 'https://readdy.ai/api/search-image?query=wide%20shot%20of%20packed%20outdoor%20festival%20grounds%20with%20colorful%20stage%20and%20string%20lights%20at%20twilight%2C%20warm%20golden%20hour%20tone%2C%20editorial%20documentary%20photography%2C%20rich%20detail&width=800&height=500&seq=rev-fest&orientation=landscape',
    link: '#',
  },
  {
    category: '综艺观察',
    title: '老牌亲子综艺为何还能让全网破防？我们回看了整季',
    excerpt: '同样主题拍了这么多年，为什么这一季能再次霸榜？嘉宾化学反应、后期节奏与话题运营的平衡，或许是答案。',
    minutes: 7,
    date: '2026-09-07',
    image: 'https://readdy.ai/api/search-image?query=warm%20family%20game%20show%20studio%20stage%20with%20bright%20lights%20and%20colorful%20sets%2C%20cheerful%20atmosphere%2C%20editorial%20television%20photography%2C%20cozy%20tone&width=800&height=500&seq=rev-show&orientation=landscape',
    link: '#',
  },
  {
    category: '热梗溯源',
    title: '一句台词火遍全网：这个网络热梗到底从哪来的',
    excerpt: '从某个深夜的评论区到刷屏各大平台只用了不到一周。我们顺着时间线，把热梗的出处、发酵与出圈全程捋了一遍。',
    minutes: 5,
    date: '2026-09-06',
    image: 'https://readdy.ai/api/search-image?query=playful%20moodboard%20of%20chat%20bubbles%20and%20lightbulb%20icons%20floating%20over%20a%20warm%20cream%20background%2C%20minimal%20editorial%20concept%20illustration%2C%20soft%20shadows&width=800&height=500&seq=rev-meme&orientation=landscape',
    link: '#',
  },
  {
    category: '市井生活',
    title: '小城夜市凭什么一夜爆火？跟随镜头走了三公里',
    excerpt: '一份炒粉、一盏暖灯、一句吆喝。我们用镜头记录一条普通夜市在短视频时代突然被看见的全过程。',
    minutes: 6,
    date: '2026-09-05',
    image: 'https://readdy.ai/api/search-image?query=bustling%20night%20market%20street%20food%20stalls%20with%20warm%20hanging%20lanterns%20and%20steam%2C%20cozy%20warm%20tone%2C%20editorial%20street%20photography%2C%20lively%20atmosphere&width=800&height=500&seq=rev-night&orientation=landscape',
    link: '#',
  },
  {
    category: '科技观察',
    title: '一个开源项目如何在一周内拿下十万星',
    excerpt: '除了代码本身，社区运营、文档体验与发布节奏缺一不可。复盘这个现象级项目爆红背后的真实路径。',
    minutes: 8,
    date: '2026-09-04',
    image: 'https://readdy.ai/api/search-image?query=modern%20developer%20desk%20with%20dual%20monitors%20showing%20code%20and%20graphs%2C%20warm%20ambient%20desk%20lamp%2C%20tech%20editorial%20photography%2C%20clean%20composition&width=800&height=500&seq=rev-oss&orientation=landscape',
    link: '#',
  },
  {
    category: '赛事背后',
    title: '业余球队的奇迹晋级之路：不被看好的逆袭全记录',
    excerpt: '从小组赛磕磕绊绊到淘汰赛连克强敌，这支业余球队用三个月书写了属于自己的黑马故事。',
    minutes: 6,
    date: '2026-09-03',
    image: 'https://readdy.ai/api/search-image?query=amateur%20football%20team%20celebrating%20together%20on%20field%20at%20sunset%2C%20silhouettes%20with%20warm%20golden%20light%2C%20inspirational%20editorial%20sports%20photography&width=800&height=500&seq=rev-up&orientation=landscape',
    link: '#',
  },
];

// 吃瓜词典（名词解释）
export const dictTerms: { term: string; pinyin: string; desc: string }[] = [
  { term: '吃瓜群众', pinyin: 'chī guā qún zhòng', desc: '指围观讨论热门事件、不亲自下场、只负责看热闹与发表看法的广大网友。' },
  { term: '实锤', pinyin: 'shí chuí', desc: '指某件事被拿出了硬核证据、基本板上钉钉，很难再反转的确认性说法。' },
  { term: '塌房', pinyin: 'tā fáng', desc: '指原本被看好的公众形象突然翻车，粉丝心中的人设「房子」塌了。' },
  { term: '破防', pinyin: 'pò fáng', desc: '指情绪防线被瞬间击穿，或被感动、或被刺激，一时难以自持的状态。' },
  { term: '加更', pinyin: 'jiā gēng', desc: '指内容或节目在原定更新之外额外放出更新，常用来回应网友「催更」。' },
  { term: '出圈', pinyin: 'chū quān', desc: '指原本只在某个小众圈子里流传的内容，忽然火到了更广的大众圈层。' },
];

// 常见问题
export const faqList: FaqItem[] = [
  {
    q: '瓜田日报的内容从哪里来？',
    a: '我们会持续盯各大平台的热榜、话题与实时讨论，从中筛选出真正有信息量、值得跟进的公开热点事件与趋势，再整理成热榜、突发与复盘三个层次呈现给大家。',
  },
  {
    q: '为什么有些事件叫「追踪中」，有些叫「已收尾」？',
    a: '标签代表事件的信息成熟度：追踪中表示事态仍在发展、我们会持续更新；新进展表示刚有重要更新；已收尾表示主要脉络已经清晰、我们完成了阶段性的梳理与复盘。',
  },
  {
    q: '我在哪里能最快看到最新热点？',
    a: '首页顶部的滚动快讯条和「全网热榜」是最快入口。突发大事区会优先展示正在发生、需要跟进的动态，你还可以按栏目切换榜单查看不同领域的热点。',
  },
  {
    q: '复盘文章会不会很长、很占时间？',
    a: '每篇复盘都标了大概阅读时长，大多在 5–9 分钟，帮你判断要不要现在读。我们也尽量把事件背景、经过与结论讲清楚，读完一篇基本能完整弄明白来龙去脉。',
  },
  {
    q: '可以订阅定期收到热点总结吗？',
    a: '可以。在页面底部的「热点晚报」填写邮箱订阅后，我们会定期把当天值得一看的热点整理成一份简报发给你，帮你用更少的时间掌握重点。',
  },
];

// 栏目分类
export const categoryList: { name: string; icon: string; desc: string; count: string }[] = [
  { name: '影视娱乐', icon: 'ri-movie-2-line', desc: '新片热剧与口碑话题', count: '128 篇' },
  { name: '综艺热播', icon: 'ri-tv-2-line', desc: '在播节目与话题复盘', count: '96 篇' },
  { name: '体育赛场', icon: 'ri-trophy-line', desc: '赛事直播与黑马故事', count: '143 篇' },
  { name: '网络热梗', icon: 'ri-chat-smile-3-line', desc: '热梗出处与用法溯源', count: '67 篇' },
  { name: '科技前沿', icon: 'ri-cpu-line', desc: '新品发布与开源观察', count: '112 篇' },
  { name: '生活百态', icon: 'ri-restaurant-2-line', desc: '烟火日常与市井故事', count: '158 篇' },
  { name: '现场直击', icon: 'ri-mic-line', desc: '演唱会与活动第一现场', count: '74 篇' },
  { name: '深度观察', icon: 'ri-compasses-2-line', desc: '现象级事件全景复盘', count: '51 篇' },
];

// 用户口碑
export const voiceList: { name: string; role: string; text: string; initials: string }[] = [
  { name: '小鹿爱追剧', role: '追剧达人', text: '以前刷热点全靠自己拼，现在每天睡前看一遍晚报就够了，第二天跟人聊天完全接得上话。', initials: '鹿' },
  { name: '夜跑的大飞', role: '体育迷', text: '复盘文章写得特别清楚，把一场比赛的爆冷前因后果全捋明白了，这比我到处翻评论强太多。', initials: '飞' },
  { name: '阿茶同学', role: '大学生', text: '吃瓜词典对我这种新手太友好了，好多词终于搞懂是啥意思，现在评论区那些梗都能看懂了。', initials: '茶' },
];